import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';

import './styles.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Loading from '../../components/Loading/Loading';

import PeriodContext from '../../Contexts/PeriodContext';
import apiTuig from '../../services/apiTuig';

import { UltimaAtualizacao, ContasAPagarDetalhado } from '../../Types/Types';
import LoginContext from '../../Contexts/LoginContext';

import { useHistory } from 'react-router-dom';

const ContasAPagar = () => {

        const Period = useContext(PeriodContext);
        const Login = useContext(LoginContext);

        const history = useHistory();

        const [contasAPagar, setContasAPagar] = useState<ContasAPagarDetalhado[]>([{
            id: '',
            descricao: '',
            fornecedor: '',
            dataVenc: '',
            valor: 0,
            error: ''
        }]);
        const [carregandoContasAPagar,setCarregandoContasAPagar] = useState(true);
        const [ultimaAtualizacao, setUltimaAtualizacao] = useState<UltimaAtualizacao>({
            ultAtualizacao: '',
            regPendentes: '',
            error: ''
        });

        useEffect(() => {
            LoadHome();       
        },[]); 

        async function CarregarUltAtualizacao() {
            try {
                if (Login.user != null) {
                    await apiTuig.get(`ultimaAtualizacao?acessKey=${Login.client}&user=${Login.user}&pass=${Login.pass}`).then(response => {
                        setUltimaAtualizacao(response.data);
                        //Se senha ou autorizacao mudar no servidor, desloga usuario
                        if (response.data.error !== '') {
                            alert(response.data.error);
                            return (
                                <div>
                                    {GoToLogin()};
                                </div>
                            )
                        }
                        })
                    }
            } catch (err) {
                alert(`Erro ao carregar hora da última atualização, verifique a conexão com a internet e tente novamente. -> ${String(err)}`);
            }
        }

        async function CarregarContasAPagar() {
            try {
                if (Login.user != null) {
                    setCarregandoContasAPagar(true);
                    await apiTuig.get<ContasAPagarDetalhado[]>(`contasAPagarDetalhado?acessKey=${Login.client}&user=${Login.user}&pass=${Login.pass}&data=${Period.dayFrom.toLocaleDateString('pt-BR', { timeZone: 'America/Recife' })}`).then(response => {
                        const conta = response.data;
                        setContasAPagar(conta);
                        setCarregandoContasAPagar(false);   
                    })
                }
            } catch (err) {
                setCarregandoContasAPagar(false);
                alert(`Erro ao carregar Contas a pagar, verifique a conexão com a internet e tente novamente. -> ${String(err)}`);
            }
        }

        useEffect(() => {
            CarregarUltAtualizacao();
            CarregarContasAPagar();
        },[]);

        function GoToLogin() {
            history.push('/');
        }
    
        function LoadHome() {
            if (sessionStorage.getItem('@tuigcloud/dayFrom') != null) {
                const momentObj = moment(sessionStorage.getItem('@tuigcloud/dayFrom'), 'DD/MM/YYYY');
                Period.dayFrom = momentObj.toDate();
            }
            Login.isAutenticated = sessionStorage.getItem('@tuigcloud/isAutenticated');
            Login.user = sessionStorage.getItem('@tuigcloud/user');
            Login.pass = sessionStorage.getItem('@tuigcloud/pass');
            Login.client = localStorage.getItem('@tuigcloud/client');
            Login.clientName = sessionStorage.getItem('@tuigcloud/clientName');

            if (Login.isAutenticated === 'true') {
                return (
                        <div id="home">
                        <div className="content">
                        <Header />
                        <br/>
                        <br/>
                        <p>Atualizado em {ultimaAtualizacao.ultAtualizacao}</p>
                        <p>{ultimaAtualizacao.regPendentes} registros a sincronizar</p>
                        <br/>
                        <h3>{Login.clientName}</h3>
                        <h1>Reposições de Caixa {Period.dayFrom.toLocaleDateString('pt-BR', { timeZone: 'America/Recife' })}</h1>
                        <br/>
                        
                        {carregandoContasAPagar ? <Loading /> : <div id="container">
                                                               {contasAPagar.map(conta => ( 
                                                               <p key={conta.id}>
                                                                   {conta.dataVenc}
                                                                   <br/>
                                                                   {conta.descricao}
                                                                   <br/>
                                                                   {conta.fornecedor}
                                                                   <br/>
                                                                   {conta.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} 
                                                               <hr/>
                                                               </p>
                                                               
                                                               ))}     
                                                               <br/>
                                                               </div>
                                                               }
                        <Footer />
                        
                    </div>
                </div>
                )
            }
            else {
                return (
                    <div>
                        {GoToLogin()};
                    </div>
                )
            }
        }
    return (
        <div>{LoadHome()}</div>
    );
};

export default ContasAPagar;
